import script from "./ActivateAutomationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivateAutomationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ActivateAutomationDialog.vue?vue&type=style&index=0&id=4d1f1da2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d1f1da2"]])